//import Message from "../../models/Message";
import axios from "axios";
import { API_BASE_URL, FETCH_LIMIT } from "../../globalVars";

export default {
  namespaced: true,

  actions: {
    async hydrate({ commit }, lastUpdateTime = null) {
      const store = this;
      const last = this.getters["entities/settings/query"]().first()
        .lastUpdateFromServer;
      await fetchNext({
        store: store,
        offset: 0,
        lastDateTime: lastUpdateTime ? lastUpdateTime : last
      });
    },

    async fetchChatMessages(context, { chatId }) {
      let store = this;
      try {
        let response = await axios({
          method: "get",
          url: API_BASE_URL + `/chat`,
          params: {
            joins: "chatMessages",
            chatId: chatId
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`
          }
        });
        if (response.data.length > 0) {
          store.dispatch("entities/chats/insertOrUpdate", {
            data: response.data[0]
          });
          store.dispatch("entities/chatMessages/insertOrUpdate", {
            data: response.data[0].chatMessages
          });
        }
        store.dispatch("entities/settings/setIsOffline", false);
      } catch (error) {
        store.dispatch("entities/settings/setIsOffline", true);
      }
    },

    async updateChat(context, chat) {
      if (chat.data && chat.data.isDirty === true) {
        const store = this;
        try {
          let response = await axios({
            method: "patch",
            url: API_BASE_URL + `/chat/${chat.data.id}`,
            data: chat.data,
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`
            }
          });
          store.dispatch("entities/update", {
            entity: "chats",
            where: parseInt(response.data.id),
            data: response.data
          });
          store.dispatch("entities/settings/setIsOffline", false);
        } catch (error) {
          store.dispatch("entities/settings/setIsOffline", true);
        }
      }
    }
  }
};

async function fetchNext({ store, offset, lastDateTime = 0 }) {
  try {
    let response = await axios({
      method: "get",
      url:
        API_BASE_URL +
        `/chat?joins=chatMessages&updatedAt[$gt]=${lastDateTime}&$limit=${FETCH_LIMIT}&$skip=${offset}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`
      }
    });
    const obj = response.data.data;
    const maxRows = response.data.total;
    let chats = [];
    let chatMessages = [];
    obj.forEach(function(chat) {
      chats.push({
        id: chat.id,
        isDirty: false,
        customerId: chat.customerId,
        contactInfoId: chat.contactInfoId,
        chatMeta: chat.chatMeta,
        chatSource: chat.chatSource,
        endedAt: Date.parse(chat.endedAt),
        createdAt: Date.parse(chat.createdAt),
        updatedAt: Date.parse(chat.updatedAt)
      });
      chatMessages.push({
        id: chat["chatMessages"][0].id,
        chatId: chat["chatMessages"][0].chatId,
        isInbound: chat["chatMessages"][0].isInbound,
        userId: chat["chatMessages"][0].userId,
        message: chat["chatMessages"][0].message,
        isRead: chat["chatMessages"][0].isRead,
        createdAt: Date.parse(chat["chatMessages"][0].createdAt),
        updatedAt: Date.parse(chat["chatMessages"][0].updatedAt)
      });
    });
    if (chats.length > 0) {
      store.dispatch("entities/chats/insertOrUpdate", {
        data: chats
      });
    }
    if (chatMessages.length > 0) {
      store.dispatch("entities/chatMessages/insertOrUpdate", {
        data: chatMessages
      });
    }
    store.dispatch("entities/settings/setIsOffline", false);
    if (maxRows > FETCH_LIMIT + offset) {
      await fetchNext({
        store,
        offset: FETCH_LIMIT + offset,
        lastDateTime
      });
    }
  } catch (error) {
    store.dispatch("entities/settings/setIsOffline", true);
  }
}
